import React from "react";
import { Divider, Flex, Popover, Typography } from "antd";
import InferredProficiencyTitle from "./components/InferredProficiencyTitle";
import ProficiencyBar from "./components/ProficiencyBar";
import SelfReportedProficiencyCell from "./components/SelfReportedProficiencyCell";
import {
  SelfReportedSubtitleStyled,
} from "./EmployeeSkillsBridgerV2.styles";
import {
  VIEW_MODE_JD,
  COL_TITLE,
  COL_WIDTH,
} from "./EmployeeSkillsBridgerV2.constants";
import { TYPE_SECONDARY } from "constants/ui.constants";

const ContextualNotesPopoverContent = ({ notes }) => (
  <Flex vertical style={{ maxWidth: 420, maxHeight: 280, overflowY: "auto" }}>
    {String(notes)
      .split("|")
      .map((s) => s.trim())
      .filter(Boolean)
      .map((para, idx) => (
        <Typography.Paragraph
          key={idx}
          style={{ fontSize: 13, lineHeight: 1.7, marginBottom: 8 }}
        >
          {para}
        </Typography.Paragraph>
      ))}
  </Flex>
);

const buildColumns = ({
  viewMode,
  selfReportedProficiencies,
  invalidInput,
  handleSelfReportedChange,
  selfReportedHeaderRef,
}) => [
  {
    title: <Typography.Text style={{ textTransform: "uppercase" }}>{COL_TITLE.SKILL_NAME}</Typography.Text>,
    dataIndex: "skill",
    width: COL_WIDTH.SKILL_NAME,
    render: (val, record) => (
      <Flex vertical>
        <Typography.Text strong>{val}</Typography.Text>
        {record.contextual_notes && (
          <Popover
            title={
              <Flex vertical gap={4}>
                <Typography.Text strong style={{ fontSize: 14 }}>
                  {val}
                </Typography.Text>
                <Divider style={{ margin: 0 }} />
              </Flex>
            }
            content={<ContextualNotesPopoverContent notes={record.contextual_notes} />}
            trigger="hover"
            placement="right"
          >
            <Typography.Paragraph
              type={TYPE_SECONDARY}
              style={{ fontSize: 13, marginBottom: 0 }}
              ellipsis={{ rows: 2 }}
            >
              {record.contextual_notes}
            </Typography.Paragraph>
          </Popover>
        )}
      </Flex>
    ),
  },
  {
    title: <InferredProficiencyTitle viewMode={viewMode} />,
    dataIndex: "profile_proficiency",
    width: COL_WIDTH.INFERRED,
    render: (val, record) => (
      <ProficiencyBar
        current={val}
        required={record.proficiency_needed}
        showRequired={viewMode === VIEW_MODE_JD}
      />
    ),
  },
  {
    title: (
      <div ref={selfReportedHeaderRef}>
        <div style={{ textTransform: "uppercase" }}>{COL_TITLE.SELF_REPORTED}</div>
        <SelfReportedSubtitleStyled type={TYPE_SECONDARY}>
          {COL_TITLE.SELF_REPORTED_SUBTITLE}
        </SelfReportedSubtitleStyled>
      </div>
    ),
    dataIndex: "skill_id",
    filterable: false,
    align: "center",
    width: COL_WIDTH.SELF_REPORTED,
    render: (skillId, record) => (
      <SelfReportedProficiencyCell
        skillId={skillId}
        profileProficiency={record.profile_proficiency}
        value={selfReportedProficiencies[skillId] ?? null}
        isInvalid={!!invalidInput[skillId]}
        onValueChange={handleSelfReportedChange}
      />
    ),
  },
];

export default buildColumns;
